import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import './ModeSelector.css';

const COOKIE_KEY = 'zoomey_mode';
const COOKIE_EXPIRY = 365; // days
const VALID_MODES = ['simple', 'smart', 'genius'];

const MODES = [
  { id: 'simple', label: 'Simple', icon: 'bi-lightning-charge-fill', description: 'Fast answers, daily tasks' },
  { id: 'smart', label: 'Smart', icon: 'bi-stars', description: 'Full power, all capabilities' },
  { id: 'genius', label: 'Genius', icon: 'bi-gem', description: 'Premium, deep personalization' },
];

/**
 * Mode Selector - Simple / Smart / Genius
 * 3-way pill toggle. Stores in cookie for persistence.
 */
const ModeSelector = ({ onModeChange }) => {
  const [selectedMode, setSelectedMode] = useState(() => {
    const saved = Cookies.get(COOKIE_KEY);
    if (saved === 'quick') return 'simple';
    return saved && VALID_MODES.includes(saved) ? saved : 'simple';
  });

  useEffect(() => {
    Cookies.set(COOKIE_KEY, selectedMode, { expires: COOKIE_EXPIRY });
    if (onModeChange) {
      onModeChange(selectedMode);
    }
  }, [selectedMode, onModeChange]);

  const cycleMode = () => {
    setSelectedMode(prev => {
      const idx = VALID_MODES.indexOf(prev);
      return VALID_MODES[(idx + 1) % VALID_MODES.length];
    });
  };

  const current = MODES.find(m => m.id === selectedMode);

  return (
    <div className="mode-selector-inline">
      <button
        className={`mode-pill-btn mode-${selectedMode}`}
        title={current?.description}
        onClick={cycleMode}
      >
        <i className={`bi ${current?.icon} mode-pill-icon`}></i>
        <span className="mode-pill-label">{current?.label}</span>
      </button>
    </div>
  );
};

export default ModeSelector;

export const getSelectedMode = () => {
  const saved = Cookies.get(COOKIE_KEY);
  if (saved === 'quick') return 'simple';
  return saved && VALID_MODES.includes(saved) ? saved : 'simple';
};
